import { lazy, Suspense } from 'react';
import { Skeleton } from 'antd';
import type { Props } from './App';
import { NotificationProvider } from './utils/notification/useNotification';

const LazyApp = lazy(() => import('./App'));
const AsyncLazyApp = (props: Props) => (
	<Suspense fallback={<Skeleton />}>
		<NotificationProvider>
			<LazyApp {...props} />
		</NotificationProvider>
	</Suspense>
);

export default AsyncLazyApp;
